import React from "react";
import Image from "next/image";
import { BASE_ASSETS_URL } from "../../../constants/constants";

const CardWithImage = ({ image, title, description, cardsStyling = "" }) => {
  return (
    <div
      className={`flex-1 w-full border-2 border-gray-800 flex flex-col gap-6 px-6 sm:px-8 pb-8 pt-8 rounded-xl transition-all duration-500 ease-in-out text-center imageBorders`}
    >
      <div className="flex items-center justify-center mx-auto w-full">
        {image && (
          <div className="h-full w-full bg-white rounded-full">
            <Image
              src={`${BASE_ASSETS_URL}/v2/landing-page/${image}`}
              alt={title}
              width={100}
              height={100}
              className="w-full h-auto rounded-xl"
            />
          </div>
        )}
      </div>
      <div className="flex flex-col gap-4 sm:px-10">
        <h3 className="text-2xl font-bold">{title}</h3>
        <p className="text-xl">{description}</p>
      </div>
    </div>
  );
};

export default CardWithImage;
